import { getContinent } from '@mahawi/eshop-common/src/get-continent';
import { getCountryName } from '@mahawi/eshop-common/src/get-country-name';
import { getFlag } from '@mahawi/eshop-common/src/get-flag';

export const getCountryString = (
  countryTypeIsoCode: string | undefined,
): string => {
  if (!countryTypeIsoCode) {
    return '';
  }

  return `${getFlag({ countryTypeIsoCode })} ${getCountryName({ countryTypeIsoCode })} (${countryTypeIsoCode}), ${getContinent({ countryTypeIsoCode })}`;
};
